/**
 * GSTIN State Code to State Name mapping (first 2 digits of GSTIN)
 */
const GSTIN_STATE_MAP = {
  '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
  '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
  '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh',
  '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram', '16': 'Tripura',
  '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
  '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh', '24': 'Gujarat',
  '25': 'Daman & Diu', '26': 'Dadra & Nagar Haveli', '27': 'Maharashtra', '28': 'Andhra Pradesh',
  '29': 'Karnataka', '30': 'Goa', '31': 'Lakshadweep', '32': 'Kerala',
  '33': 'Tamil Nadu', '34': 'Puducherry', '35': 'Andaman & Nicobar', '36': 'Telangana',
  '37': 'Andhra Pradesh (New)', '38': 'Ladakh', '97': 'Other Territory',
};

/**
 * Get state name from GSTIN number
 * @param {string} gstin - e.g. "07ABCDE1234F1Z5"
 * @returns {string} - e.g. "Delhi"
 */
export const getStateFromGstin = (gstin) => {
  if (!gstin || gstin.length < 2) return '';
  const code = gstin.substring(0, 2);
  return GSTIN_STATE_MAP[code] || '';
};

/**
 * Format client display name with GSTIN state suffix
 * @param {string} baseName - Client or Company name
 * @param {string} gstin - GSTIN number (optional)
 * @returns {string} - e.g. "ABC Private Limited (07-Delhi)"
 */
export const formatClientWithGstin = (baseName, gstin) => {
  if (!gstin) return baseName;
  const state = getStateFromGstin(gstin);
  const code = gstin.substring(0, 2);
  if (state) return `${baseName} (${code}-${state})`;
  return `${baseName} (${code})`;
};
